import { faCompressAlt, faExpandAlt, faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleCard from 'components/global/SimpleCard';
import UniversalInput from 'components/global/UniversalInput';
import { handleToggleExpandAllStageCards, handleToggleView } from 'components/global/_helpers/board.events';
import { Button, Col, Row } from 'react-bootstrap';
import { $filter, $list, $view } from 'signals/global.signals';
import { faTrello } from '@fortawesome/free-brands-svg-icons';
import { fetchAndSetDealflowData } from 'components/views/InvestorDealflow/_helpers/investorDealflow.resolvers';
import useEffectAsync from 'utils/useEffectAsync';
import InvestorDealflowCards from 'components/views/InvestorDealflow/_components/InvestorDealflowCards';
import InvestorDealflowEditModal from 'components/views/InvestorDealflow/_components/InvestorDealflowEditModal';
import InvestorDealflowDeleteModal from 'components/views/InvestorDealflow/_components/InvestorDealflowDeleteModal';
import { PIPELINE_STATUS_OPTIONS } from 'constants/globalConstants';
import { handleFilterChange } from 'components/global/_helpers/global.helpers';

const InvestorDealflowBoard = () => {
  useEffectAsync(async () => {
    await fetchAndSetDealflowData({ initView: 'grid' });
  }, []);

  return (
    <>
      <SimpleCard>
        <Row className="mb-16 pb-0 align-items-center border-bottom border-gray-700">
          <Col md={4}>
            <UniversalInput
              placeholder="Search by company name..."
              className="rounded border-0 bg-gray-700 w-100"
              name="search"
              value={$filter.value.pipelineSearch}
              onChange={(e) => handleFilterChange({ name: 'pipelineSearch', value: e.target.value })}
            />
          </Col>
          <Col md={3}>
            <UniversalInput
              type="select"
              options={PIPELINE_STATUS_OPTIONS}
              name="pipelineStatuses"
              placeholder="Filter By Status"
              isMulti
              value={PIPELINE_STATUS_OPTIONS.filter((status) => $filter.value.pipelineStatuses?.includes(status.value))}
              onChange={(selectedOptions) => {
                const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                handleFilterChange({ name: 'pipelineStatuses', value: selectedValues });
              }}
            />
          </Col>
          <Col md={3}>
            <UniversalInput
              type="select"
              options={$view.value.teamOptions}
              name="teamId"
              placeholder="Filter By Team"
              isMulti
              value={$view.value.teamOptions?.filter((status) => $filter.value.teamId?.includes(status.value))}
              onChange={(selectedOptions) => {
                const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                handleFilterChange({ name: 'teamId', value: selectedValues });
              }}
            />
          </Col>
          <Col className="d-flex justify-content-end" md={2}>
            <Button variant="transparent" onClick={() => handleToggleView('list')} className={$view.value.view == "list" && "bg-gray-700"}>
              <FontAwesomeIcon icon={faList} className="me-8 ms-8" size="1x" />
            </Button>
            <Button variant="transparent" onClick={() => handleToggleView('grid')} className={`${$view.value.view == 'grid'? 'bg-gray-700':''}`}>
              <FontAwesomeIcon icon={faTrello} className="me-8 ms-8" size="1x" />
            </Button>
            <Button variant="transparent" onClick={handleToggleExpandAllStageCards}>
              <FontAwesomeIcon icon={$view.value.openStageCards?.length > 0 ? faCompressAlt : faExpandAlt} className="me-8 ms-8" size="2xs" />
            </Button>
          </Col>
        </Row>
        <div
          className={
            $view.value.view === 'grid'
              ? 'd-flex flex-row gap-24 overflow-auto pb-2'
              : 'd-flex flex-column gap-24 pb-2'
          }
          style={
            $view.value.view === 'grid'
              ? {
                whiteSpace: 'nowrap',
                width: '100%',
                minHeight: 400,
              }
              : {
                width: '100%',
                minHeight: 400,
              }
          }
        >
          <InvestorDealflowCards dealflowData={$list.value.data || []} />
        </div>
      </SimpleCard>
      <InvestorDealflowEditModal />
      <InvestorDealflowDeleteModal />
    </>
  );
};

export default InvestorDealflowBoard;
